import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  ComponentRef,
  ComponentFactoryResolver,
  ApplicationRef,
  EmbeddedViewRef,
  HostListener,
  Renderer2,
  Injector,
} from '@angular/core';
import { TooltipContainerComponent } from './tooltip-container.component';

@Directive({
  selector: '[appTooltip]',
})
export class TooltipDirective {
  @Input('appTooltip') tooltipTemplate!: TemplateRef<any>;

  private tooltipRef!: ComponentRef<TooltipContainerComponent>;
  private viewRef!: EmbeddedViewRef<any>;

  constructor(
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private appRef: ApplicationRef,
    private renderer: Renderer2
  ) {}

  @HostListener('mouseenter', ['$event'])
  onMouseEnter(event: MouseEvent) {
    if (!this.tooltipTemplate) return;

    this.createTooltip();
    this.updatePosition(event);
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    this.updatePosition(event);
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.destroyTooltip();
  }

  private createTooltip() {
    if (this.tooltipRef) return;

    const factory = this.resolver.resolveComponentFactory(
      TooltipContainerComponent
    );

    this.tooltipRef = factory.create(this.injector);

    // Renderiza o template dentro do tooltip
    this.viewRef = this.tooltipTemplate.createEmbeddedView({});
    this.tooltipRef.instance.contentHost.insert(this.viewRef);

    this.appRef.attachView(this.tooltipRef.hostView);

    const domElem = (this.tooltipRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

    document.body.appendChild(domElem);
  }

  private updatePosition(event: MouseEvent) {
    if (!this.tooltipRef) return;

    const tooltipEl = (this.tooltipRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

    const offset = 12;
    const padding = 8;

    const rect = tooltipEl.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // 🎯 posição desejada: direita + topo
    let top = event.clientY - rect.height - offset;
    let left = event.clientX + offset;

    // 🔒 clamp vertical (não sair por cima / baixo)
    if (top < padding) {
      top = padding;
    }

    if (top + rect.height > viewportHeight - padding) {
      top = viewportHeight - rect.height - padding;
    }

    // 🔒 clamp horizontal (não sair pela direita)
    if (left + rect.width > viewportWidth - padding) {
      left = viewportWidth - rect.width - padding;
    }

    this.renderer.setStyle(tooltipEl, 'position', 'fixed');
    this.renderer.setStyle(tooltipEl, 'top', `${top}px`);
    this.renderer.setStyle(tooltipEl, 'left', `${left}px`);
    this.renderer.setStyle(tooltipEl, 'z-index', '9999');
  }

  private destroyTooltip() {
    if (!this.tooltipRef) return;

    this.appRef.detachView(this.tooltipRef.hostView);
    this.tooltipRef.destroy();

    this.tooltipRef = null!;
    this.viewRef = null!;
  }
}
